var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPeople(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.67 10.5a5.17 5.17 0 01-4.712 5.15 5 5 0 10-.374 1.35A6.5 6.5 0 107 10.416a4.964 4.964 0 011.35-.374 5.17 5.17 0 0110.32.458zM13.25 9a.75.75 0 100-1.5.75.75 0 000 1.5zM17 8.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-3.383 1.744a.625.625 0 10-.734 1.012 3.167 3.167 0 001.867.619c.692 0 1.332-.231 1.867-.619a.625.625 0 00-.734-1.012 1.918 1.918 0 01-1.133.381c-.405 0-.792-.134-1.133-.381zM9 18.67a3.67 3.67 0 100-7.34 3.67 3.67 0 000 7.34zM7.25 14.5a.75.75 0 100-1.5.75.75 0 000 1.5zm3.75-.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-3.383 1.744a.625.625 0 00-.734 1.012 3.167 3.167 0 001.867.619c.692 0 1.332-.231 1.867-.619a.625.625 0 00-.734-1.012 1.918 1.918 0 01-1.133.381c-.406 0-.792-.134-1.133-.381z",
    fill: "#231A1A"
  })));
}

export default SvgPeople;